export default __webpack_public_path__ + "static/media/s16.45d50eb7.jpg";